import * as dateFns from 'date-fns'
import React from 'react'

import { chartEventUtils } from '../../../app/charts-lib'
import { Heading } from '../../components/typography'
import { FINANCIALS_SECTION_LABELS, QuoteRoutes } from '../../constants'
import { DividendData } from './types'

type WidgetHeaderProps = Pick<
  DividendData,
  'dividendExDate' | 'lastClose' | 'dividendTTM' | 'dividendEstimate' | 'dividendsData'
>

export default function DividendsHeader({
  dividendExDate,
  dividendTTM,
  dividendEstimate,
  lastClose,
  dividendsData,
}: WidgetHeaderProps) {
  const lastDividendData = dividendsData[0]

  return (
    <div className="flex flex-col justify-between">
      <Heading level={3} className="my-0 text-muted">
        {FINANCIALS_SECTION_LABELS[QuoteRoutes.Dividends]}
      </Heading>

      <div className="mb-12 mt-6 flex justify-between">
        <div className="flex flex-col">
          <span className="text-sm text-muted">Ex-Date</span>
          <span className="text-lg">
            {dividendExDate ? dateFns.format(dateFns.parseISO(dividendExDate), 'MMM dd, yyy') : '-'}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-sm text-muted">Dividend amount</span>
          <span className="text-lg">{chartEventUtils.getFormattedValue({ value: lastDividendData.Ordinary })}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-sm text-muted">Special</span>
          <span className="text-lg">
            {lastDividendData.Special !== null
              ? chartEventUtils.getFormattedValue({ value: lastDividendData.Special })
              : '-'}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-sm text-muted">Dividend TTM</span>
          <span className="text-lg">
            {typeof dividendTTM === 'number' && typeof lastClose === 'number' ? (
              <>
                {chartEventUtils.getFormattedValue({ value: dividendTTM })} (
                {chartEventUtils.getFormattedValue({ value: (dividendTTM / lastClose) * 100 })}%)
              </>
            ) : (
              '-'
            )}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-sm text-muted">Dividend Est.</span>
          <span className="text-lg">
            {typeof dividendEstimate === 'number' && typeof lastClose === 'number' ? (
              <>
                {chartEventUtils.getFormattedValue({ value: dividendEstimate })} (
                {chartEventUtils.getFormattedValue({ value: (dividendEstimate / lastClose) * 100 })}%)
              </>
            ) : (
              '-'
            )}
          </span>
        </div>
      </div>
    </div>
  )
}
